import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-loader",
  imports: [ProgressSpinnerModule, CommonModule],
  templateUrl: "./loader.html",
  styleUrl: "./loader.scss",
})
export class Loader {
  @Input()
  is_visible: boolean = false;

  @Input() message: string = "Loading, please wait";
}
